import { createContext, useContext, useState } from 'react'

const AuthContext = createContext(null)
const SESSION_KEY = 'practicaja_session'

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(() => {
    try {
      const saved = localStorage.getItem(SESSION_KEY)
      return saved ? JSON.parse(saved) : null
    } catch { return null }
  })

  function login(user) {
    const session = { id: user._id, nombre: user.nombre, rol: user.rol }
    localStorage.setItem(SESSION_KEY, JSON.stringify(session))
    setUsuario(session)
  }

  function logout() {
    localStorage.removeItem(SESSION_KEY)
    setUsuario(null)
  }

  return (
    <AuthContext.Provider value={{ usuario, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  return useContext(AuthContext)
}
